import React from "react";
import toastr from "toastr";
import { KTMScreen } from "ktm-ui";
import { Spinner, Table } from "react-bootstrap";
import axios from "axios";
import CustomPagination from "components/CustomPagination";
import EditPlanAdminSettingModal from "components/EditPlanAdminSettingModal";
import ConfirmActionModal from "components/ConfirmActionModal";
import moment from "moment";

export default KTMScreen(
  { name: "inactive_planadmin" },
  class extends React.Component<any, any> {

    constructor(props: any) {
      super(props);
      this.state = {
        loading: true,
        planadmins: [],
        adminEmailInput: "",
        currentPage: 1,
        itemsPerPage: 8,
        isPAUpdated: false,
        pendingAction: null,
      };

      this.getInactivePlanAdmins = this.getInactivePlanAdmins.bind(this);
      this.assignAdmin = this.assignAdmin.bind(this);
      this.removeAdmin = this.removeAdmin.bind(this);
    }

    componentDidMount() {
     this.getInactivePlanAdmins();
    }

    componentDidUpdate(prevProps: any, prevState: any) {
      if (this.state.isPAUpdated !== prevState.isPAUpdated) {
        this.getInactivePlanAdmins();
        this.setState({ isPAUpdated: false });
      }
    }

    setCurrentPage = (page: number) => {
      this.setState({ currentPage: page });
    };

    requestAction = (type: "remove" | "send", row: any) => {
      this.setState({ pendingAction: { type, admin: row } });
    };

    cancelPendingAction = () => {
      this.setState({ pendingAction: null });
    };

    confirmPendingAction = () => {
      const pending = this.state.pendingAction;
      this.setState({ pendingAction: null });
      if (!pending) {
        return;
      }
      if (pending.type === "remove") {
        this.removeAdmin(pending.admin.id);
      } else {
        this.sendEmail(pending.admin.id);
      }
    };

    describeAdmin = (row: any) => {
      const name = `${row.firstName || ""} ${row.lastName || ""}`.trim();
      return name ? `${name} (${row.email})` : row.email;
    };

    renderConfirmModal = () => {
      const pending = this.state.pendingAction;
      if (!pending) {
        return null;
      }

      const who = this.describeAdmin(pending.admin);
      const isRemove = pending.type === "remove";

      return (
        <ConfirmActionModal
          title={isRemove ? "Remove plan admin" : "Send plan admin email"}
          message={
            isRemove
              ? `Remove ${who} as a plan admin for this policy?`
              : `Send the plan admin email to ${who}?`
          }
          confirmLabel={isRemove ? "Remove" : "Send Email"}
          danger={isRemove}
          onConfirm={this.confirmPendingAction}
          onCancel={this.cancelPendingAction}
        />
      );
    };

    getInactivePlanAdmins = () => {
      this.setState({ loading: true });
      axios
        .get("/api/assignplanadmin/getinactiveplanadmins?policyId=" + this.props.policy_id)
        .then((res) => {
          this.setState({
            planadmins: res.data,
            loading: false,
          });
        })
        .catch((err) => {
          toastr.error("Failed to get plan admins", "Error");
          this.setState({ loading: false });
        });
    }

    assignAdmin = async () => {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          policyId: this.props.policy_id,
          email: this.state.adminEmailInput,
        }),
      };

      try {
        const response = await fetch(
          "/api/assignplanadmin/assign",
          requestOptions
        );
        const data = await response.json();
        if(data.success) {
          this.getInactivePlanAdmins();
          toastr.success("Plan admin assigned","Success");
          this.setState({ adminEmailInput: "" });
        }
        else {
          toastr.error(data.message, "Error");
        }
      } catch (error) {
        toastr.error("Failed to assign admin", "Error");
      }
    };

    removeAdmin = (id:any) => {
      axios
      .post("/api/assignplanadmin/remove", {
        policyId: this.props.policy_id,
        userId: id,
        })
      .then((res) => {
        if(res.data.success) {
          this.getInactivePlanAdmins();
          toastr.success("Plan admin removed","Success");
        }
        else {
          toastr.error(res.data.message, "Error");
        }
      })
      .catch((err) => {
        toastr.error("Failed to remove admin", "Error");
      });
    };

    sendEmail = (id: any) => {
      axios
      .put("/api/assignplanadmin/sendpaemail", {
        policyId: this.props.policy_id,
        userId: id,
        })
      .then((res) => {
        if(res.data.success) {
          toastr.success("Email sent","Success");
          this.setState({
            isPAUpdated : true
          });
        }
        else {
          toastr.error(res.data.message, "Error");
        }
      })
      .catch((err) => {
        toastr.error("Failed to send email", "Error");
      });
    };

    render() {
      const {
        planadmins,
        loading,
        currentPage,
        itemsPerPage,
        adminEmailInput,
      } = this.state;
      const { policy_id } = this.props;

      const headers = [
        { label: "Last Name", key: "lastName", resizable: true },
        { label: "First Name", key: "firstName", resizable: true },
        { label: "Email", key: "email", resizable: true },
        { label: "Hide on EE Portal", key: "hideOnEE" },
        { label: "Receive Email", key: "receiveEmail" },
        { label: "Group PA", key: "groupPA" },
        { label: "Individual PA", key: "individualPA" },
        { label: "Show Enhanced Benefit Report", key: "showCustomCatReport" },
        { label: "2 Factor", key: "twofactor" },
        { label: "Is Trained", key: "isTrained" },
        { label: "Role", key: "role" },
        { label: "Email Send Date", key: "emailSendDate" },
        { label: "Remove", key: "remove" },
        { label: "Send Email", key: "sendEmail" },
        { label: "Edit", key: "edit" }
      ];

      const actionsContent = (
        <div
          className="RT-DataTable__list-actions"
          style={{ paddingBottom: 10, display: 'flex', alignItems: 'center' }}
        >
          <input
            className="RT-TextBox__input"
            type="text"
            placeholder="Enter admin email"
            id="paSearch"
            value={adminEmailInput}
            onChange={(event) => {
              this.setState({ adminEmailInput: event.target.value });
            }}
            style={{ backgroundColor: "white", width: "auto", height: "26px", marginRight: "8px" }}
          />
          <button
            className="RT-Button RT-Button--primary"
            onClick={this.assignAdmin}
            disabled={!this.state.adminEmailInput.trim()}
            style={{ height: "26px", width: "80px", padding: "0px" }}
          >
            Assign
          </button>
          {loading && <Spinner animation="border" size="sm" variant="primary" style={{ marginLeft: '10px' }} />}
        </div>
      );

      let tableAreaContent;

      if (loading) {
        tableAreaContent = (
          <div className="pad-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
            <Spinner
              className="pad-spinner"
              animation="border"
              variant="primary"
            />
          </div>
        );
      } else if (planadmins.length === 0) {
        tableAreaContent = (
          <div className="pad-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
            <span style={{fontWeight: "bold"}}>No plan admins found.</span>
          </div>
        );
      } else {
        const indexOfLastRecord = currentPage * itemsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - itemsPerPage;
        const currentRecords = planadmins.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(planadmins.length / itemsPerPage);

        const adminList = currentRecords.map((data) => {
          const key = data.id || data.email;
          return (
            <tr key={key}>
              <td>{data.lastName}</td>
              <td>{data.firstName}</td>
              <td style={{width:"250px"}}>{data.email}</td>
              <td>{data.hideOnEE ? "Yes" : "No"}</td>
              <td>{data.receiveEmail ? "Yes" : "No"}</td>
              <td>{data.sendGroupPAEmail ? "Yes" : "No"}</td>
              <td>{data.sendIndividualPAEmail ? "Yes" : "No"}</td>
              <td>{data.showCustomCatReport ? "Yes" : "No"}</td>
              <td>{data.twoFactor ? "Yes" : "No"}</td>
              <td>{data.isTrained ? "Yes" : "No"}</td>
              <td>{data.role == null ? "" : data.role}</td>
              <td>{data.welcomeEmailSendDate == null ? "Pending" : moment(data.welcomeEmailSendDate).format("YYYY-MM-DD")}</td>
              <td>
                <a href="#"
                  className="RT-Link"
                  onClick={(e) => { e.preventDefault(); this.requestAction("remove", data);}}
                  style={{ height: "26px", width: "80px", padding: "0px", color: "red" }}
                >
                  Remove
                </a>
              </td>
              <td>
                <a href="#"
                  className="RT-Link"
                  onClick={(e) => { e.preventDefault(); this.requestAction("send", data);}}
                  style={{ height: "26px", width: "80px", padding: "0px" }}
                >
                  Send Email
                </a>
              </td>
              <td>
                <EditPlanAdminSettingModal
                  policyId={policy_id}
                  paData={data}
                  updatePA={() => {
                    this.setState({
                      isPAUpdated: true,
                    });
                  }}
                />
              </td>
            </tr>
          );
        });

        tableAreaContent = (
          <>
            <Table hover
              style={{
                backgroundColor: "white",
                overflow: "auto",
                width: "100%",
              }}
            >
              <thead>
                <tr style={{ fontSize: "14px", fontWeight: "bold" }}>
                  {headers.map((column) => (
                    <th key={column.key} style={ column.key === "email" ? {width:"250px"} : {} }>
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {adminList.length > 0 ? adminList : (
                  <tr>
                    <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                      No plan admins to display for the current page.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            {nPages > 1 && (
              <div className="pagination-container" style={{display: "flex", justifyContent:"space-between", alignItems: "center", marginTop:"10px", marginBottom:"10px"}}>
                <div className="pagination-info">
                  <span>Showing {indexOfFirstRecord + 1} - {Math.min(indexOfLastRecord, planadmins.length)} of {planadmins.length} entries</span>
                </div>
                <CustomPagination
                  nPages={nPages}
                  currentPage={currentPage}
                  setCurrentPage={this.setCurrentPage}
                />
              </div>
            )}
          </>
        );
      }

      return (
        <div className="RT-Stackable-Container RT-Stackable-Container--embedded RT-Stackable-Container--padding-none RT-Stackable-Container--scrollable">
          <div className="RT-Stackable-Container__main">
            <div
              className="RT-Stackable-Container__body"
              style={{ display: "block" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  overflow: "unset", 
                }}
              >
                {actionsContent}
                {tableAreaContent}
                {this.renderConfirmModal()}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);